<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">

    <sc-dialog-title>
        {{ 'Basisartikeldefinition' | translate: ['erp.ui.articletype-basicarticledefinition-editor.title', translationService.language]}}
    </sc-dialog-title>
    <sc-separator-line></sc-separator-line>

    <sc-flex-fitting-content [vertical]="true">

            <sc-scroll-pane>
                <form [formGroup]="formGroup" class="no-field-space">
                  <sc-padding>
                    <sc-flex [stretchContent]="true">

                        <ng-container *ngFor="let group of articleType.attributeGroups">
                          <sc-flex-fitting-content>
                          <div>
                            <div>
                                <app-dictionary-entry-label [model]="group.name"></app-dictionary-entry-label>
                            </div>
                            <sc-content-spacer [half]="true"></sc-content-spacer>
                            <ng-container *ngFor="let attribute of group?.attributes">
                                <sc-content-spacer></sc-content-spacer>
                                <mat-checkbox [formControlName]="'attribute_' + attribute.id" class="example-margin">
                                    <app-dictionary-entry-label [model]="attribute.name"></app-dictionary-entry-label>
                                </mat-checkbox>
                            </ng-container>
                            <!-- <sc-content-spacer [double]="true"></sc-content-spacer> -->
                          </div>
                        </sc-flex-fitting-content>
                        </ng-container>
                    </sc-flex>
                  </sc-padding>
                </form>
            </sc-scroll-pane>

    </sc-flex-fitting-content>


    <sc-separator-line></sc-separator-line>
    <sc-actionbar>
        <sc-content-spacer [grow]="true"></sc-content-spacer>
        <button mat-stroked-button (click)="onClose()">
          {{ 'Abbrechen' | translate: ['erp.ui.articletype-basicarticledefinition-editor.action.cancel', translationService.language]}}
        </button>
        <sc-content-spacer></sc-content-spacer>
        <button mat-flat-button (click)="onConfirm()">
          {{ 'Übernehmen' | translate: ['erp.ui.articletype-basicarticledefinition-editor.action.confirm', translationService.language]}}
        </button>
    </sc-actionbar>
</sc-flex>
